import React from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import {
  postPatient,
  getPatientSingle,
} from "../../../../../services/PatientService";
import { useNotification } from "../../../../../context/NotificationProvider";
import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import { useAuth } from "../../../../../context/AuthProvider";
import { checkRmNumber } from "../../../../../services/Handlers/PatientService";
import { getParams } from "../../../../../utils/utils";
import LoadingSection from "../../../../components/LoadingSection";
import FormPatient from "../../Components/FormPatients";
import { formatPatientDobForApi } from "../../../../../utils/patientDob";
import { safeGoBack } from "../../../../utils/navigation";

export default function EditPatient() {
  const history = useHistory();
  const notification = useNotification();
  const localize = useLocalization();
  const { userDetail } = useAuth();
  const id = getParams("id");
  const [isCheckingRm, setIsCheckingRm] = React.useState(false);

  const { isLoadingSingle, data } = useQuery(["ActivePatientList", id], () =>
    getPatientSingle(id)
  );

  const { isLoading: isLoadingSubmit, mutate: mutateSubmit } = useMutation(
    postPatient,
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          notification.success(localize.getText("successEditData"));
          // Defer navigation one tick so notistack can mount the snackbar
          // before the route changes (otherwise the toast is unmounted
          // immediately on direct-URL/hard-refresh loads).
          setTimeout(() => safeGoBack(history, "/patient"), 0);
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    }
  );

  const handleSubmitForm = async (value) => {
    if (value.medicalRecordNumber) {
      setIsCheckingRm(true);
      try {
        const rmCheck = await checkRmNumber({
          businessId: userDetail?.businessId,
          rmNumber: value.medicalRecordNumber,
        });
        setIsCheckingRm(false);
        if (
          rmCheck.data &&
          rmCheck.data.exists &&
          String(rmCheck.data?.data?.id ?? "") !== String(id)
        ) {
          notification.error(
            rmCheck.data.message || "Nomor rekam medis sudah digunakan"
          );
          return;
        }
      } catch (error) {
        setIsCheckingRm(false);
        notification.error(localize.getText("unknownMessageError"));
        return;
      }
    }

    const alergiesDTOs = value.allergies.map((item) => ({
      ...item,
      ...(item.__isNew__ ? {} : { __isNew__: false }),
    }));

    const data = {
      ...value,
      id,
      allergy: alergiesDTOs,
      dob: formatPatientDobForApi(value.dateOfBirth),
      dateOfBirth: formatPatientDobForApi(value.dateOfBirth),
    };

    mutateSubmit(data);
  };

  if (isLoadingSingle) {
    return <LoadingSection />;
  }

  return (
    <FormPatient
      handleSubmitForm={handleSubmitForm}
      isLoadingSubmit={isLoadingSubmit || isCheckingRm}
      dataForm={data?.data}
      isEdit
    />
  );
}
